<section class="hvac-product-details-content-section hvac-product-content-section-options-data" *ngIf="showOptionsData$ | async">
    <div class="hvac-product-content-section-overview">
        <div class="hvac-product-content-section-overview-description">
            <h2 class="hvac-section-heading" [attr.id]="'PRODUCTS.OPTIONS_DATA' | translate" tabindex="-1">{{ 'PRODUCTS.OPTIONS_DATA' | translate }}</h2>
            <div class="hvac-product-content-section-text" [innerHTML]="OptionsDataTexts$ | async"></div>
        </div>
    </div>
    <hr class="hvac-section-rule">
</section>
